//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["ownerPart","instanceNum","name"],"GetInstanceName",{},1,0],[["name","ownerParts"],"SetInstanceName",{},2,0],[["ownerPart"],"GetInstanceUpdateTime",{R_:{dUpdateTime:''}},1,1],[["ownerParts","dUpdateTime"],"SetInstanceUpdateTime",{},2,1],[["ownerPart","instanceName"],"GetUpdateTimePerInstance",{R_:{dUpdateTime:''}},2,0],[["ownerParts","instanceName","dUpdateTime"],"SetUpdateTimePerInstance",{},3,0],[["ownerPart","instanceName"],"GetInstanceSaveModelPart",{R_:{bSaveModelPart:''}},2,0],[["ownerParts","instanceName","bSaveModelPart"],"SetInstanceSaveModelPart",{},3,0],[["ownerPart","instanceName","modelPath"],"SetModelPath",{},3,0],[["ownerPart","instanceName","numModel","models"],"GetInstanceModels",{},2,0],[["ownerPart","instanceName","models"],"SetInstanceModels",{},3,0],[["ownerPart","instanceName","modelName","numSignal","tagInfo"],"GetModelSignals",{},3,1],[["ownerPart","instanceName","modelName","tagInfo"],"SetModelSignals",{},4,1],[["ownerPart","instanceName","modelName","numSignal","tagInfo"],"GetModelSignalsV2",{},3,0],[["ownerPart","instanceName","modelName","tagInfo"],"SetModelSignalsV2",{},4,0],[["ownerPart","instanceName","modelName","index","nExtraType","nExtravALUE"],"GetModelSignalExtraInfo",{},4,0],[["ownerPart","instanceName","modelName","index","nExtraType","nExtravALUE"],"SetModelSignalExtraInfo",{},6,0]],[]];
SPLM.Mechatronics.FMUClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.FMUClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.FMUClientBuilder.TagInfo = class{
    constructor(strName,dataTypeName,eIOType,index,bChecked,valueReference){
        this.strName=strName;this.dataTypeName=dataTypeName;this.eIOType=eIOType;this.index=index;this.bChecked=bChecked;this.valueReference=valueReference;}
    get Strname(){return this.strName}
    set Strname(val){this.strName = val}
    get Datatypename(){return this.dataTypeName}
    set Datatypename(val){this.dataTypeName = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Index(){return this.index}
    set Index(val){this.index = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
    get Valuereference(){return this.valueReference}
    set Valuereference(val){this.valueReference = val}
};

SPLM.Mechatronics.FMUClientBuilder.TagInfoV2 = class{
    constructor(strName,dataTypeName,eIOType,index,bChecked,valueReference,eExternalDataTypes){
        this.strName=strName;this.dataTypeName=dataTypeName;this.eIOType=eIOType;this.index=index;this.bChecked=bChecked;this.valueReference=valueReference;this.eExternalDataTypes=eExternalDataTypes;}
    get Strname(){return this.strName}
    set Strname(val){this.strName = val}
    get Datatypename(){return this.dataTypeName}
    set Datatypename(val){this.dataTypeName = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Index(){return this.index}
    set Index(val){this.index = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
    get Valuereference(){return this.valueReference}
    set Valuereference(val){this.valueReference = val}
    get Eexternaldatatypes(){return this.eExternalDataTypes}
    set Eexternaldatatypes(val){this.eExternalDataTypes = val}
};

SPLM.Mechatronics.FMUClientBuilder.ModelInfo = class{
    constructor(strName,modelVersion,nUpdateTime,strFullPath){
        this.strName=strName;this.modelVersion=modelVersion;this.nUpdateTime=nUpdateTime;this.strFullPath=strFullPath;}
    get Strname(){return this.strName}
    set Strname(val){this.strName = val}
    get Modelversion(){return this.modelVersion}
    set Modelversion(val){this.modelVersion = val}
    get Nupdatetime(){return this.nUpdateTime}
    set Nupdatetime(val){this.nUpdateTime = val}
    get Strfullpath(){return this.strFullPath}
    set Strfullpath(val){this.strFullPath = val}
};

export default SPLM;